import { render, staticRenderFns } from "./FeedbackContainer.vue?vue&type=template&id=1012efe1"
import script from "./FeedbackContainer.vue?vue&type=script&lang=js"
export * from "./FeedbackContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports